export default __webpack_public_path__ + "static/media/icon-cheese.9cba36ae.png";